import { useState } from 'react'
import { CustomLink } from '../../../../../../../common/CustomLink'
import { Element } from '../../../../../../../common/html/element'
import { Icon } from '../../../../../../../common/html/icon'
import { TextEllipsisStaticLine } from '../../../../../../../common/textEllipsis/TextEllipsisStaticLine'
import { COMPONENTS } from '../../../../../../../routers/constants'

export const SelectedItem = ({ item, index, onRemoveItem }) => {
  const [isHover, setIsHover] = useState(false)

  const onMouseEnter = () => {
    setIsHover(true)
  }

  const onMouseLeave = () => {
    setIsHover(false)
  }

  return (
    <Element
      className="dFlex alignItemsCenter justifyContentBetween"
      style={{
        padding: '4px 12px',
        backgroundColor: isHover
          ? '#C8E3FF'
          : index % 2 === 0
          ? '#F9F9F9'
          : '#FFFFFF',
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <CustomLink
        target="_blank"
        to={`${COMPONENTS.companyAnalysis.components.summary.route}?organizationId=${item.id}`}
      >
        <TextEllipsisStaticLine text={item.name} lineClamp={2} isI18n={false} />
      </CustomLink>
      {isHover && (
        <div
          className="dFlex alignItemsCenter ml2"
          onClick={() => onRemoveItem(item)}
        >
          <Icon
            className="icon-delete"
            style={{ fontSize: 10, color: '#9c9c9c' }}
          />
        </div>
      )}
    </Element>
  )
}
